<ion-button *ngIf="isMyTask" expand="block" (click)="onAddAttachmentClicked()">
  {{ 'Mobile.AddAttachment' | translate }}
</ion-button>
